<template>
  <div class="quiz">
    <div v-if="!isQuiz && !isCreateQuiz" class="begin">
      <div class="header">
        <div class="flex items-center justify-between">
          <div class="title flex text-lg">
            <div class="page-name mr-2 text-black">{{ $t('quizMenu') }}</div>
          </div>
          <div class="flex gap-5 current-month ">
            <div class="search-bloc flex items-center justify-between">
              <div class="select-pays">
                <button-base
                  :label="$t('addCategoryButton')"
                  @click.native="openCreateCategory"
                />
              </div>
            </div>
            <div class="search-bloc flex items-center justify-between">
              <div class="select-pays">
                <button-base
                  :label="$t('createQuizButton')"
                  @click.native="openCreateQuiz"
                />
              </div>
            </div>
          </div>
        </div><br>
        <div class="body bg-white mt-4 p-8 rounded">
          <div class="loading" :class="{ 'not_empty': isLoading === false }">
            <loading
              :active="isLoading"
              :can-cancel="true"
              :on-cancel="onCancel"
              :is-full-page="fullPage"
              loader="dots"
              color="#0B5382"
              background-color="transparent"
            />
          </div>
          <div v-if="nothing && !isLoading" class="nothing text-center py-8 text-xl">
            {{ $t('noQuizCategoryAdded') }}
          </div>
          <div v-if="!isLoading" class="categories">
            <div class="categories-lists flex items-center justify-between flex-wrap w-full">
              <quiz-category-list
                v-for="(item, index) in allCategories"
                :key="index"
                :quiz-category-list="item"
                class="w-1/2 mr-8"
                @openQuizList="openQuizList(index)"
                @deleteCategory="handleDeleteCategory"
                @categoryUpdated="onCategoryUpdated"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- QUIZ LIST PAGE -->
    <is-quiz
      v-if="isQuiz"
      :key="quizListRefreshKey"
      :quiz-category-info="categoryInfo"
      @closeQuizList="closeQuizList"
      @updateQuiz="updateQuiz"
      @updateQuizInfo="updateQuizInfo"
      @quizDeleted="onQuizDeleted"
    />
    <!-- CREATE QUIZ PAGE -->
    <create-quiz
      v-if="isCreateQuiz"
      :is-quiz-info="quizInformation"
      @closeCreateQuiz="closeCreateQuiz"
    />
    <!-- CREATE CATEGORY MODAL -->
    <create-categorie
      :show="showCreateCategory"
      @close="closeCreateCategory"
      @categoryCreated="onCategoryCreated"
    />
  </div>
</template>

<script>
import ButtonBase from '@/components/helper/add/button-base'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import QuizCategoryList from '@/components/helper/quiz/quiz-category-list'
import http from '@/plugins/http'
import apiRoute from '@/router/api-routes'
import IsQuiz from '@/components/helper/quiz/is-quiz'
import CreateQuiz from '@/components/helper/quiz/create-quiz'
import CreateCategorie from '@/components/helper/quiz/create-categorie'

export default {
  name: 'index',
  components: { CreateCategorie, CreateQuiz, IsQuiz, QuizCategoryList, ButtonBase, Loading },
  data () {
    return {
      isLoading: true,
      fullPage: false,
      nothing: false,
      allCategories: [],
      isQuiz: false,
      categoryInfo: {},
      isCreateQuiz: false,
      quizInformation: {},
      showCreateCategory: false,
      quizListRefreshKey: 0
    }
  },
  created () {
    this.getAllCategory()
  },
  methods: {
    updateQuizInfo (val) { // GET SELECTED QUIZ INFORMATION
      this.quizInformation = val
    },
    updateQuiz (val) { // UPDATE QUIZ FROM QUIZ LIST
      this.isCreateQuiz = val
      this.isQuiz = false
      this.$store.dispatch('CREATE_NEW_QUIZ', false)
    },
    closeCreateQuiz (value) { // CLOSE CREATE QUIZ PAGE
      this.isCreateQuiz = value
      this.$store.dispatch('CREATE_NEW_QUIZ', true)
      const wasEditing = this.quizInformation && this.quizInformation.quiz
      this.quizInformation = {}
      if (wasEditing) {
        // Retour à la liste des quiz avec données fraîches
        this.quizListRefreshKey++
        this.isQuiz = true
      } else {
        // Retour aux catégories
        this.isLoading = true
        setTimeout(() => { this.isLoading = false }, 1000)
      }
    },
    openCreateQuiz () { // OPEN CREATE QUIZ PAGE
      this.isCreateQuiz = true
      this.$store.dispatch('CREATE_NEW_QUIZ', true)
    },
    closeQuizList (value) { // CLOSE QUIZ LIST PAGE
      this.isQuiz = value
      this.isLoading = true
      setTimeout(() => {
        this.isLoading = false
      }, 1000)
    },
    openQuizList (index) { // OPEN QUIZ LIST PAGE
      this.isQuiz = true
      this.categoryInfo = this.allCategories[index]
    },
    getAllCategory () { // GET BLOG CATEGORIES
      http.post(apiRoute.baseURL + apiRoute.getCategoryByType, {
        type: 'QUIZ'
      }, {
        headers: {
          Authorization: `Bearer ${this.$store.getters.loginToken}`
        }
      }).then(response => {
        // console.log(response)
        this.allCategories = response
        const icons = ['ic_aid', 'ic_sexual_gender', 'ic_transgender', 'ic_preso']
        this.allCategories.forEach((cat, i) => {
          if (icons[i]) cat.icon = icons[i]
        })
        if (this.allCategories.length === 0) {
          this.isLoading = false
          this.nothing = true
        } else {
          this.isLoading = false
          this.nothing = false
        }
      }).catch(error => {
        console.log(error)
      })
    },
    onCancel () {
      console.log('User cancelled the loader.')
    },
    openCreateCategory () { // OPEN CREATE CATEGORY MODAL
      this.showCreateCategory = true
    },
    closeCreateCategory () { // CLOSE CREATE CATEGORY MODAL
      this.showCreateCategory = false
    },
    onCategoryCreated () { // REFRESH CATEGORIES AFTER NEW CATEGORY CREATED
      this.getAllCategory()
    },
    onCategoryUpdated () { // REFRESH CATEGORIES AFTER CATEGORY UPDATED
      this.getAllCategory()
    },
    onQuizDeleted () { // REFRESH QUIZ LIST PAGE AFTER QUIZ DELETION
      this.quizListRefreshKey++
      this.getAllCategory()
    },
    handleDeleteCategory (categoryId) { // DELETE CATEGORY BY ID
      const baseDelete = apiRoute.deleteCategory || ''
      const endpoint = baseDelete.endsWith('/') ? baseDelete + categoryId : baseDelete + '/' + categoryId
      http.delete(endpoint, {
        headers: { Authorization: `Bearer ${this.$store.getters.loginToken}` }
      }).then(() => {
        this.getAllCategory()
      }).catch(err => {
        console.error('Delete error', err)
        alert('Impossible de supprimer cette catégorie. Veuillez d\'abord supprimer les quiz associés.')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "src/assets/style/sass/variables";
  .quiz {
    padding: 2rem 4rem 4rem 1.5rem;
  }
  .body {
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.05);
    min-height: 70vh;
  }
  .loading {
    position: relative;
    height: 10vh;
  }
  .not_empty {
    height: auto;
  }
  .quiz-category-list {
    width: 48%;
    &:nth-child(2n) {
      margin-right: 0;
    }
  }
</style>
